/** React */
import React, {
  Children,
  ComponentType,
  HtmlHTMLAttributes,
  ReactElement,
  ReactNode,
  cloneElement,
  isValidElement,
  useEffect,
  useState,
} from "react";

/** CSS */
import "./index.css";

/** Hooks */
import { useMenu } from "./menu-root";

/** Utils */
import { generateId } from "./menu-utils";

/** Props */
type Props = HtmlHTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
};

const ALLOWED_CHILD_COMPONENT = ["MenuButton", "MenuContent"];

export function MenuItem({ children, ...props }: Props) {
  const { addItem } = useMenu();
  const [menuId] = useState(() => generateId());

  useEffect(() => {
    addItem({
      id: menuId,
      isExpanded: true,
    });
  }, []);

  return (
    <div data-menu-id={menuId} {...props}>
      {Children.map(children, (child) => {
        if (!isValidElement(child)) return null;

        const childType = child.type as ComponentType & { displayName?: string };

        if (!ALLOWED_CHILD_COMPONENT.includes(childType.displayName)) {
          return null;
        }

        return cloneElement(child as ReactElement, {
          "data-menu-id": menuId,
        });
      })}
    </div>
  );
}

MenuItem.displayName = "MenuItem";
